import { render, staticRenderFns } from "./backBtn.vue?vue&type=template&id=0baa97cc&scoped=true"
import script from "./backBtn.vue?vue&type=script&lang=js"
export * from "./backBtn.vue?vue&type=script&lang=js"
import style0 from "./backBtn.vue?vue&type=style&index=0&id=0baa97cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baa97cc",
  null
  
)

export default component.exports